import { PreferencePDFExportType } from '@hcs/types';

interface PDFExportTypeConfig {
  pdfExportContentType: PreferencePDFExportType;
  name: string;
}

export const PDF_EXPORT_CONTENT_TYPE_CONFIGS: {
  [key in PreferencePDFExportType]: PDFExportTypeConfig;
} = {
  [PreferencePDFExportType.All]: {
    pdfExportContentType: PreferencePDFExportType.All,
    name: 'All Information (Default)',
  },
  [PreferencePDFExportType.Selected]: {
    pdfExportContentType: PreferencePDFExportType.Selected,
    name: 'Selected Report Type Only',
  },
};
